












import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../system/mixins";

@Component({
})
export default class LocatorMenu extends Mixins(ModelEditableMixin) {
}
